export class Attachment {
    id: number;
    name: string;
    type: string;
    createdBy: string;
    creationDate: Date;
    lastModified: Date;
    template: string;
    metaData: any;
}
